import { ModelSagres } from "../model-sagres"

export class ArquivoAditivo extends ModelSagres {
    IdArquivo: number
    IdAditivoContrato: number
    IdAditivoConvenio: number
    DePathArqTextoAditivo: string
    DeNomeArqTextoAditivo: string
    NmUsuarioResponsavel: string
    DtInsercao: Date
}